module.exports = __webpack_public_path__ + "img/3_125.9ae11431.png";